import React, { Component, Fragment } from 'react';
import axios from 'axios';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import withStyles from '@mui/styles/withStyles';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";

class WorkshopOrganization extends Component {
    constructor(props) {
        super(props);

        this.categories = [];

        this.state = {
            error: null,
            id: this.props.match.params.id,
            organizationName: '',
            organizationCode: '',
            category: '',
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleCategoryChange = (name, value) => {
        let selected = value;
        if (selected === null) {
            this.setState({
                category: ''
            })
            return;
        }

        this.setState({ category: JSON.parse(JSON.stringify(selected)) });
    }

    onCreate = (event) => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/organization";
        let data = {
            organizationName: this.state.organizationName,
            organizationCode: this.state.organizationCode,
            categoryId: this.state.category.value,
        }
        axios(url, 
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }, data})
        .then(response => {
            console.log("response: " + response.status);
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    onUpdate = (event) => {
        let token = sessionStorage.getItem('accessToken');
        let url = "/api/organization/" + this.state.id;
        let data = {
            organizationName: this.state.organizationName,
            organizationCode: this.state.organizationCode,
            categoryId: this.state.category.value,
        }

        axios(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },data})
        .then(response => {
            console.log("response: " + response);
            if (response.status === 200) {
                this.props.history.goBack();
            }
        });
    }

    getDetails = () => {
        if (this.props.match.params.id !== undefined) {
            var url = "/api/organization/" + this.props.match.params.id;
            axios.get(url)
                .then((p) => {
                    let catID = p.data.organization.categoryId;
                    console.log(this.categories)
                    console.log(catID);
                    console.log(this.categories.find(el => el.value === catID))

                    this.setState({
                        organizationName: p.data.organization.organizationName,
                        category: this.categories.find(el => el.value === catID),
                        organizationCode: p.data.organization.organizationCode,
                        modalMode: 'Update',
                        modalIsOpen: true
                    });
                });
        }
    }

    componentDidMount() {
        axios.get('/api/category', {
        }).then((res) => {
            res.data.categories.forEach((u) => {
                this.categories.push({ label: u.categoryName, value: u.ID });
            });
        }).then(() => this.getDetails())
            .catch(error => {
                console.log("error:" + error);
                this.setState({
                    error: error.message
                });
            });
    }

    render() {
        const { classes } = this.props;

        return (
            <ValidatorForm
                noValidate
                onSubmit={this.state.id === undefined ? this.onCreate : this.onUpdate}
            >
                <Fragment>
                    <PageHeader
                        title={"Training Provider Organization"}
                        cancel={this.props.history.goBack}
                        actionButtons={[{ label: this.state.id === undefined ? "Add" : "Update" }]}
                    />

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextValidator
                                label="Name"
                                type="text"
                                name='organizationName'
                                value={this.state.organizationName}
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                validators={['required']}
                                errorMessages={['Name is required']}
                                fullWidth
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextValidator
                                id="standard-basic"
                                label="Code"
                                className={[classes.textField].join(' ')}
                                onChange={this.handleChange}
                                value={this.state.organizationCode}
                                name='organizationCode'
                                inputProps={{ maxLength: 2}}
                                validators={['required']}
                                errorMessages={['Code is required']}
                                fullWidth
                                required
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                options={this.categories}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, val) => val === "" || option.value === val.value}
                                value={this.state.category || null}
                                onChange={this.handleCategoryChange}
                                className={[classes.autoComplete].join(' ')}
                                renderInput={(params) => <TextValidator {...params}
                                    label="Category"
                                    validators={['required']}
                                    errorMessages={['Category is required']}
                                    value={this.state.category}
                                    required
                                />}
                            />
                        </Grid>
                    </Grid>
                </Fragment>
            </ValidatorForm>
        );
    }
}

// export default WorkshopOrganization;
export default withStyles(styles, { withTheme: true })(WorkshopOrganization);
